<template>
    <form @submit.prevent="submit" novalidate="novalidate">
        <span class="p-mb-3 p-field p-col-12 form p-d-block p-d-no-padding">
            <label for="tfa-code" v-t="'label.code'"></label>
            <InputText
                :autofocus="'autofocus'"
                ref="inputTfa"
                autocomplete="one-time-code"
                id="tfa-code"
                v-model="formData.code"
                :class="{ invalid: errors.tfaCode.length }"
            />
        </span>
        <div class="input-error-container p-mb-5">
            <small
                v-if="errors.tfaCode.length"
                class="input-error"
                v-t="'errors.tfaCode.' + errors.tfaCode"
            />
        </div>
        <Button
            type="submit"
            class="p-button"
            :label="$t('button.submit')"
        ></Button>
        <Button
            type="reset"
            class="p-button-secondary"
            :label="$t('button.cancel')"
            @click="cancelLogin"
        ></Button>
    </form>
</template>

<script>
    import InputText from 'primevue/inputtext';
    import Button from 'primevue/button';
    import store from "@/store/store";

    export default {
        name       : 'Tfa',
        components : {
            Button,
            InputText,
        },
        data() {
            return {
                formData     : { code : '', remember : false },
                errorMessage : '',
                waiting      : false,
                errors       : {
                    tfaCode : '',
                },
            };
        },
        watch : {
            'formData.code' : function () {
                this.errors.tfaCode = '';
            },
        },
        methods : {
            isFormValid() {
                let isValid = true;
                if (this.formData.code.length < 1) {
                    this.errors.tfaCode = 'empty';
                    isValid = false;
                }
                return isValid;
            },
            checkAccess() {
    	        if (!store.getters.isAwaiting2FA) {
    		        this.$router.push({name : 'login'});
    	        }
            },
            submit() {
                if (!this.isFormValid()) {
                    return;
                }
                this.$emit('submit', 'sendTfa', this.formData, 'home');
            },
            cancelLogin() {
                this.$store
                    .dispatch('logout')
                    .then(() => this.$router.push('login'));
            },
        },
        beforeMount(){
    	    this.checkAccess()
        },
    };
</script>

<i18n src="myra-ui-common/i18n/common.json" />
<i18n src="./i18n.json" />
